import { useCallback } from 'react';
import allActions from '../actions/index';
import { useDispatch } from 'react-redux';

const useEventEmitter = (componentName) => {
    const dispatch = useDispatch();

    const applyEmitterHandler = useCallback((emitterHandler) => {
        dispatch(allActions.eventEmitterActions.eventEmitterThunk(componentName, emitterHandler));
    }, [dispatch, componentName]);

    return applyEmitterHandler;
}

export default useEventEmitter;